module.exports = __webpack_public_path__ + "static/media/sap-gif.dc8b126e.webm";